var map = {
	"./add.svg": 1480,
	"./arrow.svg": 7190,
	"./avatar.svg": 256,
	"./bbdd.svg": 1659,
	"./calendar.svg": 5033,
	"./cartografia.svg": 1648,
	"./circle.svg": 7183,
	"./cross.svg": 9973,
	"./edit.svg": 975,
	"./enter-key.svg": 4865,
	"./exit.svg": 5960,
	"./eye.svg": 4426,
	"./filter.svg": 7985,
	"./form.svg": 217,
	"./gear.svg": 7046,
	"./geo-pin.svg": 8136,
	"./grahp.svg": 4785,
	"./grahpMain.svg": 3022,
	"./headphones.svg": 2582,
	"./headphonesMain.svg": 8641,
	"./helmet.svg": 2276,
	"./help.svg": 5330,
	"./horizontal.svg": 7143,
	"./layers.svg": 3465,
	"./link.svg": 1119,
	"./list.svg": 71,
	"./m-edit.svg": 5717,
	"./m-eye.svg": 4708,
	"./m-geo-pin.svg": 2606,
	"./minus.svg": 8441,
	"./pencil.svg": 184,
	"./plus.svg": 4491,
	"./punctual.svg": 5501,
	"./quick.svg": 2808,
	"./redo.svg": 2727,
	"./ref-top.svg": 2544,
	"./search.svg": 4343,
	"./send.svg": 6385,
	"./siav.svg": 4034,
	"./simple-arrow.svg": 2245,
	"./sort-asc.svg": 8051,
	"./sort-desc.svg": 1419,
	"./sort-none.svg": 798,
	"./status-label.svg": 9072,
	"./text.svg": 6606,
	"./tolomeo.svg": 2692,
	"./trash.svg": 6891,
	"./tutti.svg": 8367,
	"./undo.svg": 7305
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6669;